/**
 * Read-more modals — `.modal.modal--readmore` opened via `data-ir-open-readmore-modal`
 * (gateModal / setLastFocused from theme bundle). Used by Impact side by side,
 * Impact card slider, and Impact columns callout; handler is registered once if multiple sections load this file.
 */
(function bootImpactReadmoreModal(attempts) {
  attempts = attempts || 0;
  if (typeof jQuery === "undefined") {
    if (attempts < 100) {
      setTimeout(function () {
        bootImpactReadmoreModal(attempts + 1);
      }, 50);
    }
    return;
  }

  if (window.__tmImpactReadmoreModalBound) {
    return;
  }
  window.__tmImpactReadmoreModalBound = true;

  var $ = jQuery;

  $(document).on("click", "[data-ir-open-readmore-modal]", function (e) {
    e.preventDefault();
    if (typeof setLastFocused === "function") {
      setLastFocused($(e.currentTarget));
    }

    var controls = e.currentTarget.getAttribute("aria-controls");
    var $modal = $();
    if (controls && document.getElementById(controls)) {
      $modal = $(document.getElementById(controls));
    } else {
      $modal = $(e.currentTarget).closest(".shopify-section").find(".modal--readmore");
    }
    if (!$modal.length) {
      $modal = $(".modal--readmore").first();
    }
    if (!$modal.length) {
      return;
    }

    $modal.fadeIn("fast", function () {
      if (typeof gateModal === "function") {
        gateModal($modal.find(".modal__wrap"));
      }
    });
  });
})(0);
